import { ErrorCode } from '../constants';

export type ErrorMessageCodeType = {
  errorCode?: string; // string codes from ErrorCode enum (e.g. 'INSUFFICIENT_OUTPUT_AMOUNT')
  context?: string; // numeric code in string from ErrorCode enum (e.g. '-43603')
  error?: {
    code: number; // numeric codes from ErrorCode enum (e.g. -43603)
  };
};

export type ErrorMessagesType = {
  [key in string | number]: string;
};

/**
 * @function
 * @description Gets an error message based on a given error code and an object of error messages.
 * @param {ErrorMessageCodeType} code - Object containing optional errorCode, context, and error properties.
 * @param {ErrorMessagesType} errorMessages - Object of error messages.
 * @return {string}  The error message that corresponds to the given error code, or an empty string if not found.
 */
export const getErrorMessage = (code: ErrorMessageCodeType, errorMessages: ErrorMessagesType): string => {
  let errorCode: string | number;

  // knownErrorType is a boolean indicating whether there is a `code` matches "ErrorCode" enum error code.
  const knownErrorType = code && code.errorCode ? code.errorCode === ErrorCode[code.errorCode] : false;
  // gasFeeError is a boolean indicating whether there is an error related to gas fees.
  const gasFeeError =
    code?.context === ErrorCode.INTERNAL_JSON_RPC_ERROR.toString() ||
    code?.error?.code === ErrorCode.INTERNAL_JSON_RPC_ERROR;

  if (knownErrorType) {
    errorCode = code?.errorCode && ErrorCode[code.errorCode];
  } else if (gasFeeError) {
    errorCode = ErrorCode.INTERNAL_JSON_RPC_ERROR;
  } else {
    errorCode = ErrorCode.DEFAULT_CONFIRM_SWAP_ERROR;
  }

  return errorMessages[errorCode];
};
